import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonButtons, IonMenuButton, IonBackButton } from '@ionic/react';
import CreateSalesActivity from '../components/CreateSalesActivity';
import { useLocation } from 'react-router';
const SalesActivity: React.FC = () => {

    const location = useLocation();
    const salesActivity = (location.state as any)?.salesActivity;
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton />
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>
                        {!!salesActivity?.id ? "Update Activity" : "Add Activity"}
                    </IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">
                            {!!salesActivity?.id ? "Update Activity" : "Add Activity"}
                        </IonTitle>
                    </IonToolbar>
                </IonHeader>
                <CreateSalesActivity salesActivity={salesActivity} />
            </IonContent>
        </IonPage>
    );
};

export default SalesActivity;
